import { useTranslation } from 'react-i18next';
import { api } from '../api/client';
import { Btn } from '../components/ui';
import { CODAI_PENDING_KEY } from '../api/token';

export function AuthScreen() {
  const { t } = useTranslation();
  return (
    <div className="splash-page"><div className="splash">
      <img className="splash-logo" src="/brand/logo-full.png" alt={t('app.name')} width={300} height={300} />
      <p className="tagline">{t('app.tagline')}</p>
      <Btn variant="primary" block onClick={() => {
        try { sessionStorage.setItem(CODAI_PENDING_KEY, '1'); } catch { /* ignore */ }
        window.location.href = api.codaiUrl();
      }}>{t('auth.continueWith')}{' '}<img src="/codai-logo.png" alt="Codai" className="codai-mark" /></Btn>
      <p className="center muted" style={{ marginTop: 18 }}>{t('auth.by')}{' '}<img src="/codai-logo.png" alt="Codai" className="codai-mark" />.</p>
    </div></div>
  );
}
